import { render, staticRenderFns } from "./PersonalCardForm.vue?vue&type=template&id=483071e8&scoped=true"
import script from "./PersonalCardForm.vue?vue&type=script&lang=js"
export * from "./PersonalCardForm.vue?vue&type=script&lang=js"
import style0 from "./PersonalCardForm.vue?vue&type=style&index=0&id=483071e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483071e8",
  null
  
)

export default component.exports